// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.1
//   protoc               v4.23.4

/* eslint-disable */

export * from "./bounties_app/bounties_app";
